export const NEXTJS_NODEJS_IMPORT_YAML = `project:
  name: recipe-nextjs
  tags:
    - zerops-recipe

services:
  - hostname: app
    type: nodejs@20
    enableSubdomainAccess: true
    buildFromGit: https://github.com/zeropsio/recipe-nextjs-nodejs`;
